import { Reveal } from "./Reveal";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";

const cards = [
  { src: "/adv-1.webp", alt: "Prima di curare, ascoltiamo" },
  { src: "/adv-2.webp", alt: "Un percorso chiaro dà più tranquillità" },
  { src: "/adv-3.webp", alt: "Un'équipe accanto a te" },
  { src: "/adv-4.webp", alt: "Tornare a godersi le cose semplici" },
  { src: "/adv-5.webp", alt: "Non pensavo di tornare a sorridere" },
];

export const BrandCarousel = () => (
  <section id="filosofia" className="py-24 md:py-32 px-6 md:px-12 bg-[#DDEBF2]" data-testid="brand-carousel-section">
    <div className="max-w-7xl mx-auto">
      <Reveal>
        <p className="text-sm uppercase tracking-[0.2em] font-bold text-[#7D9285] mb-4">La nostra filosofia</p>
        <h2 className="font-serif-display font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#15201A] max-w-3xl">
          Prima di curare, <em className="italic text-[#385244]">ascoltiamo</em>
        </h2>
      </Reveal>
      <Reveal delay={0.15}>
        <Carousel opts={{ loop: true, align: "start" }} className="mt-14">
          <CarouselContent>
            {cards.map((c, i) => (
              <CarouselItem key={c.src} className="sm:basis-1/2 lg:basis-1/3" data-testid={`brand-slide-${i}`}>
                <figure>
                  <img src={c.src} alt={c.alt} width="1080" height="1080" className="w-full rounded-[24px] border border-border" loading="lazy" decoding="async" />
                  <figcaption className="mt-4 text-lg md:text-xl font-bold text-[#15201A] text-center">{c.alt}</figcaption>
                </figure>
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious className="left-2 bg-white/90 border-border text-[#385244] hover:bg-[#385244] hover:text-white" data-testid="brand-prev-btn" />
          <CarouselNext className="right-2 bg-white/90 border-border text-[#385244] hover:bg-[#385244] hover:text-white" data-testid="brand-next-btn" />
        </Carousel>
      </Reveal>
    </div>
  </section>
);
